import { useState, useEffect } from "react";
import { Modal } from "semantic-ui-react";

type Payment2C2PModalProps = {
  data: any;
  onSuccess?: () => void;
  onCanceled?: () => void;
  onUnknown?: () => void;
};
// const Payment2C2PModal = (props: any) => {

//   return (<>
//     <Modal
//       open={true}
//       size="fullscreen"
//     >
//       <ModalContent>
//         <button id="button_payment_ui" type="button" onClick={() => {
//           const uiRequestMandatory = {

//             url: props.webPaymentUrl
//           };

//           //or

//           const uiRequestFull = {

//             url: props.webPaymentUrl,
//             templateId: "ikea",
//             mode: "DropIn",
//             appBar: true,
//             cancelConfirmation: true
//           };

//           PGWSDK.paymentUI(uiRequestFull, function (response) {

//             console.log(response);

//             if (response.responseCode == "0003") {

//               //User canceled transaction
//             } else if (response.responseCode == "2000") {

//               let transactionStatusInquiry = response.transactionStatusInquiry;

//               if (transactionStatusInquiry) {

//                 //Handle transaction status inquiry API response or redirect to your payment result page.
//               } else {

//                 //Request payment inquiry API or redirect to your payment result page.
//               }
//             } else {

//               console.log("Response callback: " + response.paymentToken + " // " + response.responseCode + " // " + response.responseDescription);
//             }
//           });
//         }
//         }>Submit Payment UI</button>
//         <button id="button_payment_submit" type="button" onClick={() => {
//           PGWSDK.submitPayment("submit_gcard")
//         }}>Submit Payment Submit</button>

//       </ModalContent>
//     </Modal>
//   </>)
// }
const Payment2C2PModal = (props: Payment2C2PModalProps) => {
  const [open, setOpen] = useState(true);

  // const iframeRef = useRef(null);

  useEffect(() => {
    // Handle payment post messages
    const handlePaymentPostMessages = ({ data }) => {
      const { paymentResult } = data;

      if (!paymentResult) {
        return;
      }

      console.log("paymentResult: ", paymentResult);
      const { respCode, respDesc, respData } = paymentResult;

      // Handle response codes
      // alert(`${respCode}: ${respDesc}: ${respData}`);

      if (respCode === "2000") {
        /// 00 - transaction success. (GREEN)
        // 01 - transaction failed. (RED)
        // 02 - general message. (GREY)
        if (respData?.additionalInfo?.paymentResultDetails?.code !== "00") {
          // Customer Cancellation (02 )
          // props.onFailed?.() // --- อาจจะเอาไปใช้กรณี Failed จาก Payment Process
          props.onCanceled?.();
          setOpen(false);
        } else if (respData?.additionalInfo?.paymentResultDetails?.code === "00")
          props.onSuccess?.();
        setOpen(false);
      }
    };

    // Subscribe to post messages
    window.addEventListener("message", handlePaymentPostMessages);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("message", handlePaymentPostMessages);
    };
  }, []);

  // const triggerSubmitPayment = (paymentType = 'submit_gcard') => {
  //   if (iframeRef.current) {
  //     // Possible types to trigger:
  //     // submit_gcard     - Global Credit Card
  //     // submit_lcard     - Local Credit Card
  //     // submit_dpay      - Digital Payment
  //     // submit_qr        - QR Payment
  //     // submit_counter   - Counter Payment
  //     // submit_ssm       - Self Service Machine
  //     // submit_webpay    - Web Payment / Direct Debit
  //     // submit_imbank    - iBanking / mBanking
  //     // submit_gbnpl     - Global Buy Now Pay Later

  //     iframeRef.current.contentWindow.postMessage(paymentType, '*');
  //   }
  // };

  return (
    <Modal
      open={open}
      style={{
        height: props.data?.paymentChannel === "CC" ? "80%" : "90%",
        width: "90%",
      }}
      closeOnDimmerClick={false}
      closeOnEscape={false}
      size={"large"}
      onClose={() => {
        setOpen(false);
        props.onUnknown?.();
      }}
      closeIcon={props.data?.paymentChannel !== "CC"}
    >
      <iframe
        // ref={iframeRef}
        name="output_frame"
        id="output_frame"
        src={props.data?.webPaymentUrl}
        onError={(error) => {
          console.log("error", error);
        }}
        width="100%"
        height="100%"
        style={{ border: "1px solid #ccc", minHeight: "100%" }}
        title="Payment Gateway"
      />
    </Modal>
  );
};

export default Payment2C2PModal;
